<template>
    <div class="download">
        <div class="top">
            <img src="../assets/images/img_logo_v2.png" />
            <span>MyChevy</span>
        </div>
        <div class="middle"><img  src="../assets/images/a1.png"></div>
        <div class="bottom"><img src="../assets/images/download_btn.png" @click="download"></div>
    </div>
</template>
<script>
    export default {
        name: "download",
        methods: {
            download(){
                window.location.href = "https://itunes.apple.com/cn/app/mychevy/id587800848";
            }
        }
    }
</script>
<style lang="less" scoped>
    .download {
        font-family: "PingFangSC-Regular";
        color: #333333;
        text-align: center;
        padding-top: 31px;
        .top {
            img {
            width: 40px;
            height: 40px;
            margin-right: 18px;
            vertical-align: middle;
            }
            span {
            font-size: 24px;
            vertical-align: middle;
            }
        }
        .middle{
            margin-top: 44px;
            img {
                width: 266px;
                height: 266px;
            }
        }
        .bottom{
            margin-top: 40px;
            img {
            width: 236px;
            height: 44px;
            }
        }
    }
</style>